module.exports = __webpack_public_path__ + "img/12.bf42af59.png";